import CoinInfo from "./CoinInfo";
export default CoinInfo;
